import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import { pure } from '@dbk/ui-react-utils';
import { createContainer } from '@dbk-legacy/muster/react';

import KeyValueListView from '../../../components/common/key-value-list-view';
import AbbreviatedGroup from '../../../components/common/abbreviated-group';
import TransactionDetailsDescription from './transaction-details-description';

import styles from './transaction-details.styles';

function TransactionDetails(props) {
  const {
    row,
    detailsGroups,
    abbreviationRules,
    description,
    descriptionMaxChars,
    referenceCurrency,
    headerGroup,
    messages
  } = props;

  const abbreviatedGroupComponent = (
    <AbbreviatedGroup
      data={{
        ...row,
        maturityValueUnit: referenceCurrency,
      }}
      dataDefinitions={headerGroup}
      abbreviationRules={abbreviationRules}
      renderTopSeparator={false}
      renderBottomSeparator={true}
    />
  );

  return (
    <View style={styles.root} testID="expandable-item" accessible={true}>
      <View testID="details">
        {abbreviatedGroupComponent}
        {detailsGroups.length > 0 &&
          <KeyValueListView
            row={row}
            detailsGroups={detailsGroups}
            abbreviationRules={abbreviationRules}
            renderFirstSeparator={false}
            messages={messages}
          />
        }
      </View>
      <TransactionDetailsDescription
        description={row.name}
        maxChars={descriptionMaxChars}
        messages={messages}/>
    </View>
  );
}

TransactionDetails.propTypes = {
  row: PropTypes.shape({
    maturityValue: PropTypes.number,
    maturityValueAlt: PropTypes.number,
    maturityValueAltUnit: PropTypes.string,
    valueDate: PropTypes.string,
  }),
  detailsGroups: KeyValueListView.propTypes.detailsGroups,
  abbreviationRules: PropTypes.object,
  description: PropTypes.string,
  descriptionMaxChars: PropTypes.number,
  referenceCurrency: PropTypes.string,
  headerGroup: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    key: PropTypes.string,
    type: PropTypes.string,
  })),
};

TransactionDetails.defaultProps = {
  detailsGroups: [],
};

export default pure(TransactionDetails);
